import React from 'react'
import PaymentIcons from '../../organisms/PaymentIcons'
import {
  spiritSupportEmail,
  prolineSupportEmail,
} from '../../../constants/constants'
import { isProline } from '../../../helpers'
import { useSiteContext } from '../../../context/site/SiteProvider'
import { Link } from 'react-router-dom'
import { useUserContext } from '../../../context/user/UserProvider'

interface IWholesaleInfoProps {}

const WholesaleInfo: React.FC<IWholesaleInfoProps> = ({}) => {
  const { storeSettings } = useSiteContext()
  const { isDarkMode } = useUserContext()
  return (
    <div className="mt-3 ms-3">
      <div className="text-accent fw-bold">
        {isProline() ? "'76 Pro Line" : 'Sales Office'} Hours (CST)
      </div>
      <div
        dangerouslySetInnerHTML={{
          __html: storeSettings?.text_hours_left_side || '',
        }}
      />
      <div>
        <Link
          to="/tent-video"
          className={isDarkMode ? 'text-dm-hidden' : 'text-white'}
        >
          Videos
        </Link>
      </div>

      <div className="text-accent fw-bold">Card Options:</div>
      <PaymentIcons className="mt-3" />
      <br />
      <div className="text-accent fw-bold">Contact Info</div>
      {isProline() ? (
        <div>Phone: {storeSettings?.proline_phone_number}</div>
      ) : (
        <div>Phone: {storeSettings?.spirit_phone_number}</div>
      )}
      <div>Email: {isProline() ? prolineSupportEmail : spiritSupportEmail}</div>
    </div>
  )
}

export default WholesaleInfo
